import {
  TBlueObj,
  TBlueTable,
  TDBContractor,
  TISOCountry,
} from "@app/types/insider";

import { epBuilderAnyIssuerNoSlices } from "../routines/mapperfn-pathbuilder";

export const contractors_cff: TBlueTable<TDBContractor> = {
  name: "contractors_cff",
  empty: {} as TDBContractor,
  initialState: {},
  primaryKey: "CFF_ID",
  apiUrl: "/select/ss_contractors_cff",
  pkeyUrl: "/select/ss_contractors_cff_pkey",
  mapWrite: (data) => data,
  mapRead: (data) => data,
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  starfx: true,
  idb: true,
  starfx_index: "CIF",
  idb_indexes: [
    {
      name: "CIF",
      keyPath: "CIF",
    },
  ],
  bootPriority: 1,
  onmru: "ifempty",
  oncsdb: "full",
  label: "Contractori fiscale",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
type TDBContractorTemp = TDBContractor & {
  CFFTMP_ID: number;
};
export const contractors_temp: TBlueTable<TDBContractorTemp> = {
  name: "contractors_temp",
  empty: {} as TDBContractorTemp,
  initialState: {},
  primaryKey: "CFFTMP_ID",
  apiUrl: "/select/ss_contractors_temp",
  pkeyUrl: "/select/ss_contractors_temp_pkey",
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  mapWrite: (data) => data,
  mapRead: (data) => data,
  starfx: true,
  idb: true,
  starfx_index: "CIF",
  idb_indexes: [
    {
      name: "CIF",
      keyPath: "CIF",
    },
  ],
  bootPriority: 1,
  onmru: "ifempty",
  oncsdb: "full",
  label: "Contractori temporari",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
export const contractors_anaf: TBlueTable<TDBContractor> = {
  name: "contractors_anaf",
  empty: {} as TDBContractor,
  initialState: {},
  primaryKey: "CIF",
  apiUrl: null,
  pkeyUrl: null,
  mapWrite: (data) => data,
  mapRead: (data) => data,
  starfx: true,
  idb: false,
  bootPriority: -1,
  onmru: "no",
  oncsdb: "no",
  label: "Contractori ANAF",
  appContext: [],
};

/* 
  ISOID INTEGER NOT NULL,
  COD_NATIONAL VARCHAR(5) NOT NULL,
  DEN_NATIONAL VARCHAR(255),
  COD_SUBDIV VARCHAR(20),
  DEN_SUBDIV VARCHAR(255));

*/
export const iso3166_2: TBlueTable<TISOCountry> = {
  name: "iso3166_2",
  empty: {} as TISOCountry,
  initialState: {},
  primaryKey: "ISOID",
  pkeyUrl: "/select/ss_iso3166_2_pkey",
  apiUrl: "/select/ss_iso3166_2",
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  mapWrite: (data) => data,
  mapRead: (data) => data,
  starfx: true,
  idb: true,
  starfx_index: "ISOID",
  idb_indexes: [],
  bootPriority: 1,
  onmru: "no",
  oncsdb: "full",
  label: "ISO 3166-2",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const isoNewCities: TBlueTable<TISOCountry> = {
  name: "isoNewCities",
  empty: {} as TISOCountry,
  initialState: {},
  apiUrl: null,
  primaryKey: "ISOID",
  starfx: true,
  idb: false,
  starfx_index: "ISOID",
  idb_indexes: [],
  bootPriority: -1,
  onmru: "no",
  oncsdb: "no",
  label: "ISO New Cities",
  appContext: ["CtxPersonalKarma"],
};
